// Generic promise-based choice dialog (#choiceModal in index.html). Resolves with the chosen
// value, or null on Cancel / backdrop-click / Escape. Mirrors the other modal overlays. Used to
// ask how far a batch edit should reach (visible vs all, matching vs all).

export interface Choice { label: string; value: string; primary?: boolean }

const overlay = document.getElementById("choiceModal") as HTMLElement;
const titleEl = document.getElementById("choiceTitle") as HTMLElement;
const msgEl = document.getElementById("choiceMsg") as HTMLElement;
const actionsEl = document.getElementById("choiceActions") as HTMLElement;

let resolveCurrent: ((v: string | null) => void) | null = null;

function close(value: string | null): void {
  if (!resolveCurrent) return;
  const done = resolveCurrent;
  resolveCurrent = null;
  overlay.hidden = true;
  actionsEl.innerHTML = "";
  done(value);
}

overlay.addEventListener("mousedown", (e) => { if (e.target === overlay) close(null); }); // backdrop-click
// capture-phase so an open dialog swallows Esc before the global menu/modal handler
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && !overlay.hidden) { e.stopPropagation(); close(null); }
}, true);

export function askChoice(opts: { title: string; message: string; choices: Choice[] }): Promise<string | null> {
  if (resolveCurrent) close(null); // superseded by a new prompt
  titleEl.textContent = opts.title;
  msgEl.textContent = opts.message;
  actionsEl.innerHTML = "";
  const cancel = document.createElement("button");
  cancel.className = "tool";
  cancel.textContent = "Cancel";
  cancel.onclick = () => close(null);
  actionsEl.appendChild(cancel);
  for (const c of opts.choices) {
    const btn = document.createElement("button");
    btn.className = "tool" + (c.primary ? " primary" : "");
    btn.textContent = c.label;
    btn.onclick = () => close(c.value);
    actionsEl.appendChild(btn);
  }
  overlay.hidden = false;
  return new Promise((res) => { resolveCurrent = res; });
}
